module.exports = __webpack_public_path__ + "img/trusted-company-2.556ea810.png";